import LoginPage from '../../../global/pages/Login/LoginPage.vue';
import ForgotPassword from '../../../global/pages/Login/ForgotPassword.vue';
import ResetPassword from '../../../global/pages/Login/ResetPassword.vue';

export default [
  {
    component: LoginPage,
    path: '/login',
    name: 'LoginPage',
    meta: {
      title: 'Login',
    },
  },
  {
    component: LoginPage,
    path: '/dashboard/login',
    name: 'DashboardLoginPage',
    meta: {
      title: 'Login',
    },
  },
  {
    component: ForgotPassword,
    path: '/forgot-password',
    name: 'ForgotPassword',
    meta: {
      title: 'ForgotPassword',
    },
  },
  {
    component: ResetPassword,
    path: '/reset-password/:resetKey',
    name: 'ResetPassword',
    meta: {
      title: 'ResetPassword',
    },
  },
  {
    name: 'LogoutRoute',
    path: '/logout',
    beforeEnter() { window.location.href = '/logout'; },
  },

];
